import { RouteRecordRaw, createRouter, createWebHashHistory,createWebHistory } from 'vue-router';
import { App } from 'vue'
const routes: RouteRecordRaw[] = [
    {
        path: '/',
        name: 'home',
        redirect: '/index.aps'
    },
    {
        path: '/index.aps',
        name: 'index.aps',
        component: () => import('../views/index.vue'),
        meta: {
            title: '首页',
        },
    },
    {
        path: '/about.html',
        name: 'about.html',
        component: () => import('../views/about/index.vue'),
        meta: {
            title: '关于我们',
        }
    },
    {
        path: '/products.html',
        name: 'products.html',
        component: () => import('../views/products/control_cabinet.vue'),
        meta: {
            title: '控制柜',
        }
    },
    {
        path: '/particular/:id',
        component: () => import('../views/products/particular.vue'),
    },
    {
        path: '/Exhibition.html',
        name: 'Exhibition.html',
        component: () => import('../views/products/Exhibition.vue'),
        meta: {
            title: '产品展示',
        }
    },
    {
        path: '/terminal.html',
        name: 'terminal.html',
        component: () => import('../views/products/terminal.vue'),
        meta: {
            title: '行业终端设备',
        }
    },
    {
        path: '/wisdom.html',
        name: 'wisdom.html',
        component: () => import('../views/products/wisdom.vue'),
        meta: {
            title: '智慧管控平台',
        }
    },
    {
        path: '/performance.html',
        name: 'performance.html',
        component: () => import('../views/case_list/performance.vue'),
        meta: {
            title: '工程业绩',
        }
    },
    {
        path: '/application_case.html',
        name: 'application_case.html',
        component: () => import('../views/case_list/application_case.vue'),
        meta: {
            title: '应用案例',
        }
    },
    {
        path: '/realistic_picture.html',
        name: 'realistic_picture.html',
        component: () => import('../views/case_list/realistic_picture.vue'),
        meta: {
            title: '工程实景图',
        }
    },
    {
        path: '/partner.html',
        name: 'partner.html',
        component: () => import('../views/partner/index.vue'),
        meta: {
            title: '合作伙伴',
        }
    },
    {
        path: '/contact.html',
        name: 'contact.html',
        component: () => import('../views/contact/index.vue'),
        meta: {
            title: '联系方式',
        }
    },
    // 跳转404
    {
        path: "/:pathMatch(.*)",
        name: "404",
        component: () => import("../404.vue"),
        meta: {
            title: '页面找不到'
        }
    },
    {
        path: '/join_us.html',
        name: 'join_us.html.html',
        component: () => import('../views/contact/joinUs.vue'),
        meta: {
            title: '加入我们',
        }
    },
    {
        path: '/enterprise_culture.html',
        name: '/enterprise_culture.html',
        component: () => import('../views/about/EnterpriseCulture.vue'),
        meta: {
            title: '企业文化',
        }
    },
    {
        path: '/qualification_honor.html',
        name: '/qualification_honor.html',
        component: () => import('../views/about/QualificationHonor.vue'),
        meta: {
            title: '资质荣誉',
        }
    }
]
const router = createRouter({
    history: createWebHistory(),
    routes
})
router.beforeEach((to, from, next) => {
    window.scroll(0, 0)
    if (to.meta.title) {
        document.title = `${to.meta.title}-南通宇启升机电设备有限公司`
    }
    next();
})
export const initRouter = (app: App<Element>) => {
    app.use(router)
}